<template>
	<span>
		<v-container fluid fill-height class="hero" style="max-height: 50vh;">
			<v-row align-center justify-center fill-height >
				<v-col class="text-center headline">
					<h1 class="font-weight-black" >آموزش پیوسته، رمز توسعه پایدار</h1>
				</v-col>
				<v-spacer class="hidden-md-and-down" ></v-spacer>
			</v-row>
		</v-container>
	</span>
</template>

<script>
	export default {
		name: "DocsHero"
	};
</script>

<style scoped>
	.hero {
		background: url("~@/assets/img/docs-hero.png");
		background-size: cover;
		width: 100%;
		height: 100%;
	}
</style>
